import React, { Component } from 'react';

class FacebookForm extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }


  render() {
    return (
      <div>
        <form
          style={{ maxWidth: '400px', position: 'relative' }}
          method="post"
          onSubmit={{}}
          className="form__admin  form__admin--greyBg  u-padding-small"
        >

        facebook form

        </form>
      </div>
    );
  }


}


export default FacebookForm;



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/FacebookForm.js